export enum InvoiceStatusEnum {
  INVOICE_WAITING_UPLOAD = "INVOICE_WAITING_UPLOAD", //Aguardando Notas
  INVOICE_ON_APPROVAL = "INVOICE_ON_APPROVAL", //Notas Emitidas/Em Aprovação
  INVOICE_APPROVED = "INVOICE_APPROVED", //Notas Aprovadas
  INVOICE_NOT_ACCEPTED = "INVOICE_NOT_ACCEPTED" //Notas não aprovadas
}

export enum ServiceNfStatusEnum {
  NF_WAITING_UPLOAD = "NF_WAITING_UPLOAD", //Aguardando Envio
  NF_ON_APPROVAL = "NF_ON_APPROVAL", //Em Aprovação
  NF_APPROVED = "NF_APPROVED", //Aprovado
  NF_NOT_APPLICABLE = "NF_NOT_APPLICABLE", //Não se aplica
  NF_NOT_ACCEPTED = "NF_NOT_ACCEPTED" //NF não aceita
}

export enum PartsNfStatusEnum {
  NF_WAITING_UPLOAD = "NF_WAITING_UPLOAD", //Aguardando Envio
  NF_ON_APPROVAL = "NF_ON_APPROVAL", //Em Aprovação
  NF_APPROVED = "NF_APPROVED", //Aprovado
  NF_NOT_APPLICABLE = "NF_NOT_APPLICABLE", //Não se aplica
  NF_NOT_ACCEPTED = "NF_NOT_ACCEPTED" //NF não aceita
}
